import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "station-form-category-container" }
const _hoisted_2 = { class: "station-form-category-content" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import { usePositionStore } from '@/pinia-store/usePositionStore'
import { CompanyDoctorInviteStatusEnum } from '@/Network/Types/Requests/CompanyRequests'

// `stacked`: uma coluna com largura cheia (Criar plantão em tela cheia no celular, R6).

export default /*#__PURE__*/_defineComponent({
  __name: 'locale.and.schedule.form',
  props: [
  'company',
  'healthUnit',
  'schedule',
  'companyErr',
  'healthUnitErr',
  'scheduleErr',
  'doctor',
  'stacked'
],
  emits: [
  'update:company',
  'update:healthUnit',
  'update:schedule',
  'update:doctor',
  'update:requiresDoctorPaymentFormation'
],
  setup(__props, { emit }) {


/* eslint-disable sonarjs/no-duplicate-string */


const healthUnitStore = useHealthUnitStore()
const scheduleStore = useScheduleStore()
const doctorStore = useDoctorStore()
const { listCompanies } = storeToRefs(useCompanyStore())
const { listHealthUnitsByCompany } = storeToRefs(useHealthUnitStore())
const { listSchedules } = storeToRefs(useScheduleStore())

const positionStore = usePositionStore()

const isLoadingUnits = ref(false)
const isLoadingSchedules = ref(false)

const setCompany = async (v: string) => {
  isLoadingUnits.value = true

  const companyId = Number(v)
  emit('update:company', Number(companyId))
  emit('update:healthUnit', undefined)
  emit('update:schedule', undefined)
  emit('update:doctor', undefined)

  try {
    await healthUnitStore.setHealthUnitsByCompany(companyId)

    await doctorStore.applyFilters(
      {
        search: '',
        names: [],
        crms: [],
        crmUFs: [],
        companies: [String(companyId)],
        inviteStatus: [
          CompanyDoctorInviteStatusEnum.ACCEPTED,
          CompanyDoctorInviteStatusEnum.PENDING
        ]
      },
      false
    )
  } catch (error) {
    console.error('Erro ao carregar unidades ou médicos:', error)
  } finally {
    isLoadingUnits.value = false
  }
}

const setHealthUnit = async (v: string) => {
  isLoadingSchedules.value = true

  const healthUnitId = Number(v)
  emit('update:healthUnit', healthUnitId)
  emit('update:schedule', undefined)

  try {
    await scheduleStore.setSchedulesByHealthUnit(healthUnitId)
  } catch (error) {
    console.error('Erro ao carregar escalas:', error)
  } finally {
    isLoadingSchedules.value = false
  }
}

const setSchedule = async (v: string) => {
  const scheduleId = Number(v)
  const selectedSchedule = listSchedules.value.find((s) => s.value === v)

  await positionStore.getByScheduleId(scheduleId)
  emit('update:schedule', Number(scheduleId))

  if (selectedSchedule) {
    emit('update:requiresDoctorPaymentFormation', selectedSchedule.requiresDoctorPaymentFormation)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex", __props.stacked ? 'flex-col gap-2' : 'flex-wrap gap-4'])
      }, [
        _createVNode(_component_v_autocomplete, {
          "onUpdate:modelValue": setCompany,
          items: _unref(listCompanies),
          "model-value": __props.company ? String(__props.company) : undefined,
          class: "flex-1 min-w-0 md:min-w-[200px]",
          color: "primary20",
          label: "Empresa",
          theme: "light",
          variant: "outlined",
          density: "comfortable",
          "error-messages": __props.companyErr
        }, null, 8, ["items", "model-value", "error-messages"]),
        _createVNode(_component_v_autocomplete, {
          "onUpdate:modelValue": setHealthUnit,
          items: _unref(listHealthUnitsByCompany),
          "model-value": __props.healthUnit ? String(__props.healthUnit) : undefined,
          disabled: !__props.company,
          loading: isLoadingUnits.value,
          class: "flex-1 min-w-0 md:min-w-[200px]",
          color: "primary20",
          label: "Unidade",
          variant: "outlined",
          density: "comfortable",
          "error-messages": __props.healthUnitErr
        }, null, 8, ["items", "model-value", "disabled", "loading", "error-messages"]),
        _createVNode(_component_v_autocomplete, {
          "onUpdate:modelValue": setSchedule,
          items: _unref(listSchedules),
          "model-value": __props.schedule ? String(__props.schedule) : undefined,
          disabled: !__props.healthUnit,
          loading: isLoadingSchedules.value,
          class: "flex-1 min-w-0 md:min-w-[200px]",
          color: "primary20",
          label: "Escala",
          theme: "light",
          variant: "outlined",
          density: "comfortable",
          "error-messages": __props.scheduleErr
        }, null, 8, ["items", "model-value", "disabled", "loading", "error-messages"])
      ], 2)
    ])
  ]))
}
}

})